import { meshTheme } from './theme'

export const hexToRGBA = (hexVal, opacity = 100) => {
  const hex = hexVal.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
}

export const linearGradient = (colorStart, colorFinish, options = {}) => {
  // (
  //   'linear-gradient(' +
  //   angle +
  //   ', ' +
  //   hexToRGBA(colorStart, opacity) +
  //   ' -9.18%, ' +
  //   hexToRGBA(colorFinish, opacity) +
  //   ' 209.09%)'
  // )
  console.log(colorStart, colorFinish)
  const {
    angle = 0,
    startOffset = 0,
    endOffset = 100,
    opacityStart = 100,
    opacityFinish = 100
  } = options
  const colorA = `${hexToRGBA(meshTheme.global.colors[colorStart], opacityStart)} ${startOffset}%`
  const colorB = `${hexToRGBA(meshTheme.global.colors[colorFinish], opacityFinish)} ${endOffset}%`
  return `linear-gradient(${angle}deg, ${colorA}, ${colorB})`
}
